import { CustomFieldsDefinitionKit, CustomFieldItem } from './types';

export enum TypeKeys {
    CB_CUSTOM_FIELD_DEFINITIONS_LOADED = 'customFields/CB_CUSTOM_FIELD_DEFINITIONS_LOADED',
    QUESTION_CUSTOM_FIELD_DEFINITIONS_LOADED = 'customFields/QUESTION_CUSTOM_FIELD_DEFINITIONS_LOADED',
    QUESTION_SET_CUSTOM_FIELD_DEFINITIONS_LOADED = 'customFields/QUESTION_SET_CUSTOM_FIELD_DEFINITIONS_LOADED',
    CONTENT_SOUND_CUSTOM_FIELD_DEFINITIONS_LOADED = 'customFields/CONTENT_SOUND_CUSTOM_FIELD_DEFINITIONS_LOADED',
    SET_INITIAL_REVIEW_CUSTOM_FIELDS = 'customFields/SET_INITIAL_REVIEW_CUSTOM_FIELDS',
    PUBLISH_STATUS_CHANGED = 'contentCustomFields/PUBLISH_STATUS_CHANGED',
    PUBLISH_STATUS_CHANGE_PUSHED = 'contentCustomFields/PUBLISH_STATUS_CHANGE_PUSHED',
    EDIT_CUSTOM_FIELDS_METADATA = 'contentCustomFields/EDIT_CUSTOM_FIELDS_METADATA',
    CUSTOM_METADATA_FIELD_CHANGE_PUSHED = 'contentCustomFields/CUSTOM_METADATA_FIELD_CHANGE_PUSHED',
    CUSTOM_METADATA_FIELD_IN_CONTEXT_CHANGE_PUSHED = 'contentCustomFields/CUSTOM_METADATA_FIELD_IN_CONTEXT_CHANGE_PUSHED',
    CUSTOM_FIELDS_DEFINITION_KIT_CHANGED = 'contentCustomFields/CUSTOM_FIELDS_DEFINITION_KIT_CHANGED',
    CUSTOM_METADATA_FIELDS_LOADER_CHANGED = 'contentCustomFields/CUSTOM_METADATA_FIELDS_LOADER_CHANGED',
    SET_IS_REVIEW_FIELDS = 'contentCustomFields/SET_IS_REVIEW_FIELDS',
    DATEABLE_CHANGED = 'itemproperty/DATEABLE_CHANGED',
    DATEABLE_CHANGED_PUSHED = 'itemproperty/DATEABLE_CHANGED_PUSHED'
}

export type SectionCustomFieldDefinitionsLoaded = {
    type: TypeKeys.CB_CUSTOM_FIELD_DEFINITIONS_LOADED;
    payload: Array<any>;
}

export type QuestionCustomFieldDefinitionsLoaded = {
    type: TypeKeys.QUESTION_CUSTOM_FIELD_DEFINITIONS_LOADED;
    payload: Array<any>;
}
export type QuestionSetCustomFieldDefinitionsLoaded = {
    type: TypeKeys.QUESTION_SET_CUSTOM_FIELD_DEFINITIONS_LOADED;
    payload: Array<any>;
}

export type ContentSoundCustomFieldDefinitionsLoaded = {
    type: TypeKeys.CONTENT_SOUND_CUSTOM_FIELD_DEFINITIONS_LOADED;
    payload: Array<any>;
}

export type PublishStatusChanged = {
    type: TypeKeys.PUBLISH_STATUS_CHANGED;
    payload: {
        contentItemId: number;
        publishStatus: string;
    };
}

export type DateableChanged = {
    type: TypeKeys.DATEABLE_CHANGED;
    payload: {
        contentItemId: number;
        itemProperty: string;
        value: number;
    };
}

export type PublishStatusChangePushed = {
    payload: boolean;
    type: TypeKeys.PUBLISH_STATUS_CHANGE_PUSHED;
}
export type DateableChangePushed = {
    payload: boolean;
    type: TypeKeys.DATEABLE_CHANGED_PUSHED;
}

export type EditCustomFieldsMetadata = {
    type: TypeKeys.EDIT_CUSTOM_FIELDS_METADATA;
    payload: {
        contentItemId: number;
        customFieldUpdates: Array<CustomFieldItem>;
        contextContentItemId?: number;
        callback?: () => void;
    };
}
export type CustomMetadataFieldChangePushed = {
    type: TypeKeys.CUSTOM_METADATA_FIELD_CHANGE_PUSHED;
}

export type CustomMetadataFieldInContextChangePushed = {
    type: TypeKeys.CUSTOM_METADATA_FIELD_IN_CONTEXT_CHANGE_PUSHED;
}

export type CustomMetadataFieldsLoaderChanged = {
    type: TypeKeys.CUSTOM_METADATA_FIELDS_LOADER_CHANGED;
    payload: boolean;
}

export type SetInitialReviewCustomFieldsDefinitionKit = {
    type: TypeKeys.SET_INITIAL_REVIEW_CUSTOM_FIELDS;
}

export type SetIsReviewFields = {
    type: TypeKeys.SET_IS_REVIEW_FIELDS;
    payload: boolean;
}

export type CustomFieldsDefinitionKitChanged = {
    type: TypeKeys.CUSTOM_FIELDS_DEFINITION_KIT_CHANGED;
    payload: CustomFieldsDefinitionKit[];
}

export const sectionCustomFieldDefinitionsLoaded = (payload: Array<any>): SectionCustomFieldDefinitionsLoaded => ({
    type: TypeKeys.CB_CUSTOM_FIELD_DEFINITIONS_LOADED,
    payload,
});

export const questionCustomFieldDefinitionsLoaded = (payload: Array<any>): QuestionCustomFieldDefinitionsLoaded => ({
    type: TypeKeys.QUESTION_CUSTOM_FIELD_DEFINITIONS_LOADED,
    payload,
});
export const questionSetCustomFieldDefinitionsLoaded = (payload: Array<any>): QuestionSetCustomFieldDefinitionsLoaded => ({
    type: TypeKeys.QUESTION_SET_CUSTOM_FIELD_DEFINITIONS_LOADED,
    payload,
});

export const contentSoundCustomFieldDefinitionsLoaded = (payload: Array<any>): ContentSoundCustomFieldDefinitionsLoaded => ({
    type: TypeKeys.CONTENT_SOUND_CUSTOM_FIELD_DEFINITIONS_LOADED,
    payload,
});


export const publishStatusChanged = (publishStatus: string, contentItemId: number): PublishStatusChanged => {
    return {
        type: TypeKeys.PUBLISH_STATUS_CHANGED,
        payload: {
            contentItemId,
            publishStatus,
        },
    };
};

export const dateableChanged = (contentItemId: number, itemProperty: string, value: number): DateableChanged => {
    return {
        type: TypeKeys.DATEABLE_CHANGED,
        payload: {
            contentItemId,
            itemProperty,
            value,
        },
    };
};

export const editCustomFieldsMetadata = (
    contentItemId: number,
    customFieldUpdates: any,
    contextContentItemId?: number,
    callback?: () => void,
): EditCustomFieldsMetadata => ({
    type: TypeKeys.EDIT_CUSTOM_FIELDS_METADATA,
    payload: {
        contentItemId,
        contextContentItemId,
        customFieldUpdates,
        callback,
    },
});

export const setInitialReviewCustomFieldsDefinitionKit = (): SetInitialReviewCustomFieldsDefinitionKit => ({
    type: TypeKeys.SET_INITIAL_REVIEW_CUSTOM_FIELDS,
});

export const setIsReviewFields = (payload: boolean): SetIsReviewFields => ({
    type: TypeKeys.SET_IS_REVIEW_FIELDS,
    payload,
});

export const customFieldsDefinitionKitChange = (payload: Array<any>): CustomFieldsDefinitionKitChanged => ({
    type: TypeKeys.CUSTOM_FIELDS_DEFINITION_KIT_CHANGED,
    payload,
});

export const customMetadataFieldChangePushed = (): CustomMetadataFieldChangePushed => ({
    type: TypeKeys.CUSTOM_METADATA_FIELD_CHANGE_PUSHED,
});

export const customMetadataFieldInContextChangePushed = (): CustomMetadataFieldInContextChangePushed => ({
    type: TypeKeys.CUSTOM_METADATA_FIELD_IN_CONTEXT_CHANGE_PUSHED,
});

export const customMetadataFieldsLoaderChanged = (payload: boolean): CustomMetadataFieldsLoaderChanged => ({
    type: TypeKeys.CUSTOM_METADATA_FIELDS_LOADER_CHANGED,
    payload,
});

export const publishStatusChangePushed = (payload: boolean): PublishStatusChangePushed => ({
    payload,
    type: TypeKeys.PUBLISH_STATUS_CHANGE_PUSHED,
});

export const dateableChangePushed = (payload: boolean): DateableChangePushed => ({
    payload,
    type: TypeKeys.DATEABLE_CHANGED_PUSHED,
});

export type ActionTypes = SectionCustomFieldDefinitionsLoaded
    | QuestionCustomFieldDefinitionsLoaded
    | QuestionSetCustomFieldDefinitionsLoaded
    | ContentSoundCustomFieldDefinitionsLoaded
    | PublishStatusChanged
    | PublishStatusChangePushed
    | DateableChangePushed
    | EditCustomFieldsMetadata
    | CustomMetadataFieldChangePushed
    | CustomMetadataFieldInContextChangePushed
    | CustomFieldsDefinitionKitChanged
    | CustomMetadataFieldsLoaderChanged
    | SetInitialReviewCustomFieldsDefinitionKit
    | DateableChanged
    | SetIsReviewFields;
